module.exports = __webpack_public_path__ + "static/volunteer-network-73ca0ddf7f6723235a2d0915fc9196f8.gif";